var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_671","data-name":"Group 671","transform":"translate(-287.343 -23.343)"},[React.createElement("rect",{"id":"Rectangle_475","data-name":"Rectangle 475","width":"14","height":"2","transform":"translate(288.757 23.343) rotate(45)","fill":"#f6f6f6","key":0}),React.createElement("rect",{"id":"Rectangle_476","data-name":"Rectangle 476","width":"14","height":"2","transform":"translate(298.657 24.757) rotate(135)","fill":"#f6f6f6","key":1})]));
}

CloseInline.defaultProps = {"width":"11.313","height":"11.314","viewBox":"0 0 11.313 11.314"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
